import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  gridRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(3, 4),
  },
  label: {
    fontSize: '12px',
    lineHeight: '16px',
    color: theme.palette.labraText.description,
  },
  value: {
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.labraText.primary,
  },
  subValue: {
    fontSize: '14px',
    lineHeight: '20px',
    color: theme.palette.labraText.description,
  },
}))
